import * as React from "react"
import { Grid } from "@mui/material"
import {string, object, array} from "yup";
import { DrawerSeeker, TextFieldSeeker, SelectSeeker, TagFieldSeeker } from "@ui-seeker/core"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import { isEmpty } from '@ui-seeker/utils'

import {StockChangesReportFormIsOpen} from "../@signals";
import {useStockChangesReportForm} from "../@hooks";
import { OPTIONS_FREQUENCY, STOCK_STATUS } from "./constants"


export default function StockChangesReportFormDrawer() {
	const { showToast } = useAppToast()
	const { handleSendToBack, nameReport, frequency, emailsReport, conditions, resetFormData } = useStockChangesReportForm()

	const validatorData = useValidatorSeeker({
        nameReport: nameReport.value,
		frequency: frequency.value,
        emailsReport: emailsReport.value,
    }, object({
        nameReport: string().required('Report name must be provided'),
		frequency: string().required('Frequency must be provided'),
        emailsReport: array().min(1, 'At least 1 email is required')
    }))

	if (!StockChangesReportFormIsOpen.value) return <></>
	
    return <DrawerSeeker
		isOpen={StockChangesReportFormIsOpen.value}
		controller={() => {
			StockChangesReportFormIsOpen.value = false
			resetFormData()
		}}
		title={`Create New Stock Changes Report`}
		width="40%"
		successProps={{ onClick: isEmpty(validatorData.errors)
			? handleSendToBack
			: () => showToast.warning('Please ensure all mandatory fields are completed ') 
		}}
	>
    	<Grid container spacing={3}>
			<Grid item xs={12}>
				<TextFieldSeeker
					error={validatorData.errors?.nameReport}
					label="Report Name"
					size="small"
					fullWidth
					value={nameReport.value}
					onChange={e => nameReport.value = e.target.value}
					icon="pen-to-square"
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.frequency}
					label="Frequency"
					fullWidth
					options={OPTIONS_FREQUENCY}
					value={frequency.value}
					onChange={e => frequency.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.conditions}
					label="Final Stock Status"
					fullWidth
					multiple={true}
					isClearable={true}
					options={STOCK_STATUS}
					value={conditions.value}
					onChange={e => conditions.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<TagFieldSeeker
					error={validatorData.errors?.emailsReport}
					value={emailsReport.value}
					fullWidth
					onChange={e => emailsReport.value = e }
					label="Emails"
					placeholder="Enter to add emails"
				/>
			</Grid>

		</Grid>
    </DrawerSeeker>
}